import { Component, OnInit } from "@angular/core";
import * as moment from "moment";
import { DialogService } from "primeng/dynamicdialog";
import { UserService } from "../../../shared";
import { SchoolService } from "../../../shared/services/school.service";
import { SchoolselectorService } from "../../schoolselector/schoolselectorservice.service";
import { MergeToGroupDialogComponent } from "../merge-to-group-dialog/merge-to-group-dialog.component";
import { MergeToGroupRequest } from "../report-services/merge-to-group-request";
import { ReportService } from "../report.service";

@Component({
	selector: "app-timestamp-scanning-by-school",
	templateUrl: "./timestamp-scanning-by-school.component.html",
	styleUrls: ["./timestamp-scanning-by-school.component.css"],
})
export class TimestampScanningBySchoolComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		private schoolService: SchoolService,
		private reportService: ReportService,
		private dialogService: DialogService,
		private userService: UserService
	) {}

	report = {
		SchoolID: 0,
		StartDate: new Date(),
		EndDate: new Date(),
		TimeScanTypeID: 0,
		HideSchoolsWOScans: 0,
		SortByID: "SchoolName",
		SortDirectionID: "ASC",
		ImageLogo: "",
	};

	schoolList: any = [];
	timeScanTypeDescList: any = [];
	ImageLogoList: any = [];

	HideSchoolsWOScansList: any = [
		{
			ID: 0,
			Desc: "Show All",
		},
		{
			ID: 1,
			Desc: "Hide Schools With No Scans",
		},
	];

	SortByList: any = [
		{
			ID: "SchoolName",
			Desc: "School Name",
		},
		{
			ID: "SchoolNumber",
			Desc: "School Number",
		},
		{
			ID: "ScanCount",
			Desc: "Scan Count",
		},
		{
			ID: "DistinctStudentCount",
			Desc: "# of Students Scanning",
		},
		{
			ID: "ActiveStudentCount",
			Desc: "Students in each School",
		},
	];

	SortDirectionList: any = [
		{
			ID: "ASC",
			Desc: "Ascending",
		},
		{
			ID: "DESC",
			Desc: "Descending",
		},
	];

	OutputTypeID: any = 1;
	OutputTypeList = [
		{
			ID: 1,
			Desc: ".PDF",
		},
		// {
		//     ID: 2,
		//     Desc: ".Doc (Word Document)" //Doesn't seem to work
		// },
		// {
		//     ID: 3,
		//     Desc: ".xls (Excel file)" //Ending Support for xls, just use CSV
		// },
		{
			ID: 4,
			Desc: ".CSV (Excel file)",
		},
		{
			ID: 5,
			Desc: ".RTF (Rich Text File)",
		},
		// {
		//     ID: 6,
		//     Desc: ".XML" //Doesn't seem to work
		// },
		{
			ID: 7,
			Desc: ".HTM (Web Page)",
		},
		// {
		//     ID: 8,
		//     Desc: ".rpt" //Doesn't seem to work
		// },
		// {
		//     ID: 9,
		//     Desc: ".grp" //Doesn't seem to work
		// }
	];

	ReportID: number = 482;
	subscription: any;

	user: any;
	errorMessage: any = "";
	isProcessing: any = false;

	ngOnInit() {
		// this.loadSchoolist();
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school.SchoolID);
		});
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	private loadLogolist() {
		var result = this.reportService.ImageLogoGetList("", this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.ImageLogoList = response;

				this.report.ImageLogo = this.ImageLogoList[0].ImageLibraryID;
			},
			(error) => {}
		);
	}

	onSchoolChange(value) {
		this.report.SchoolID = value;
		this.TimeScanTypeList();
		this.loadLogolist();
	}

	private TimeScanTypeList() {
		this.report.TimeScanTypeID = 0;
		var result = this.reportService.TimeScanTypeGetList(this.report.SchoolID);
		result.subscribe(
			(response) => {
				this.timeScanTypeDescList = response;

				// Remove All Scan Types
				if (this.timeScanTypeDescList.length > 0) {
					if (this.timeScanTypeDescList[0].TimeScanTypeID <= 0) {
						this.timeScanTypeDescList.splice(0, 1);
					}
				}

				this.report.TimeScanTypeID = this.timeScanTypeDescList[0].TimeScanTypeID;
			},
			(error) => {}
		);
	}

	Print() {
		var component = this;
		this.errorMessage = "";

		this.isProcessing = true;

		var strParam = this.GetStrParam();

		var result = this.reportService.Print(this.ReportID, strParam, this.report.SchoolID, this.OutputTypeID);
		result.subscribe(
			(response: any) => {
				component.isProcessing = false;
				window.open(response);
			},
			(error) => {
				component.errorMessage = error;
				component.isProcessing = false;
			}
		);
	}

	GetStrParam(): string {
		var strParam: string = "";

		strParam += this.user.userID + "|UserID";
		strParam += "," + moment(this.report.StartDate).format("MM/DD/YYYY") + "|StartDate";
		strParam += "," + moment(this.report.EndDate).format("MM/DD/YYYY") + "|EndDate";
		strParam += "," + this.report.TimeScanTypeID + "|TimeScanTypeID";
		strParam += "," + this.report.HideSchoolsWOScans + "|HideSchoolsWOScans";
		strParam += "," + this.report.SortByID + "|SortBy";
		strParam += "," + this.report.SortDirectionID + "|SortDirection";
		strParam += "," + this.report.SchoolID + "|SchoolID";
		strParam += "," + this.report.ImageLogo + "|Imagelogo";

		return strParam;
	}

	MergeToGroup() {
		this.errorMessage = "";

		this.isProcessing = true;
		var strParam = this.GetStrParam();

		var parms: MergeToGroupRequest = {
			ReportID: this.ReportID,
			SchoolID: this.report.SchoolID,
			strParms: strParam,
		};

		var result = this.reportService.MergeToGroupSelectInfo(parms);
		result.subscribe(
			(response: any) => {
				if (response.length > 0) {
					var ref = this.dialogService.open(MergeToGroupDialogComponent, {
						header: "Merge to Group",
						width: "fit-content",
						data: {
							//INSERT Custom Data here
							lstPerson: response,
							SchoolID: this.report.SchoolID,
						},
					});
					ref.onClose.subscribe((response) => {
						if (response == 1) {
						}
					});
				} else {
					this.errorMessage = "No Data available";
				}

				this.isProcessing = false;
			},
			(error) => {
				this.errorMessage = error;
				this.isProcessing = false;
			}
		);
	}
}
